module.exports = __webpack_public_path__ + "static/media/技术力量.7a14ef1d.png";